import React from 'react'
import dkVideo from '../../../video/AboutDigikalaVideo.mp4'
import cx from 'classnames'
import styles from './DKExploreHomeVideoEn.module.css'
import H2El from '../../Elements/H2El/H2El'
import ParagraphEl from '../../Elements/ParagraphEl/ParagraphEl'
import ReadMoreBtnEl from '../../Elements/ReadMoreBtnEl/ReadMoreBtnEl'
import LazyLoad from 'react-lazy-load'
import ReactPlayer from 'react-player'
import Link from 'next/link'
import { sharedData } from '../../Data/sharedData'

const DKExploreHomeVideoEn = () => {
  return (
    <>
      <div
        className={cx(
          styles.sliderContent,
          'w-100',
          'h-100',
          'position-relative',
          'd-none',
          'd-lg-flex'
        )}
      >
        <LazyLoad offset={200}>
          {/* <ReactPlayer
                    url={dkVideo}
                    playing={true}
                    loop={true}
                    controls={false}
                    muted={true}
                    className={cx(styles.video)}
                    playsInline={true}
                  /> */}
          <video
            muted
            loop
            playsInline
            controls={false}
            autoPlay
            className={cx(styles.video)}
          >
            <source src={dkVideo} />
          </video>
        </LazyLoad>
        <div className={cx(styles.sliderOverlay, 'position-absolute')}></div>
        <div className={cx(styles.slidesInfo, 'position-absolute')}>
          <div className='w-100 d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-between'>
            <div className='d-flex flex-column flex-xl-row align-items-xl-center align-items-start justify-content-center'>
              <H2El extraClasses={[styles.titleMarginBottom]}>
                Digikala Explore
              </H2El>
              <span
                className={cx(styles.verticalLine, 'd-xl-flex', 'd-none')}
              ></span>
              <p className={cx(styles.paragraphStyls, styles.paraMarginBottom)}>
                Up Until Today, More Than 5000 People Have Visited Digikala.
              </p>
              {/* <ParagraphEl extraClasses={[styles.paraMarginBottom]}>
              </ParagraphEl> */}
            </div>
            <div className='d-flex align-items-center justify-content-center'>
              <Link
                aria-label='read more'
                href={`https://explore.digikala.com/${sharedData.utmParamsEn}`}
                target='_blank'
                className={cx(
                  styles.readmoreBtnStyles,
                  'd-flex',
                  'align-items-center',
                  'justify-content-center'
                )}
              >
                Explore the Digikala Universe
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div
        className={cx(
          styles.sliderContentMobile,
          'w-100',
          'h-100',
          'position-relative',
          'd-lg-none',
          'd-flex'
        )}
      >
        <div
          className={cx(
            styles.innerContainerMobile,
            'w-100',
            'd-flex',
            'flex-column',
            'align-items-center',
            'justify-content-start'
          )}
        >
          <h2
            className={cx(
              styles.videoTitleMobile,
              'w-100',
              'd-flex',
              'align-items-center',
              'justify-content-center',
              'pe-2'
            )}
          >
            Digikala Explore
          </h2>
          <div
            className={cx(
              styles.mobileVideoWrapper,
              'd-flex',
              'align-items-center',
              'justify-content-center',
              'w-100'
            )}
          >
            {/* <ReactPlayer
                      url={dkVideo}
                      playing={true}
                      loop={true}
                      controls={false}
                      muted={true}
                      playsInline={true}
                    /> */}
            <video
              muted
              loop
              playsInline
              controls={false}
              autoPlay
              className={cx(styles.video)}
            >
              <source src={dkVideo} />
            </video>
          </div>
          {/* <LazyLoad
                    className={cx(
                      styles.innerContainerMobileVideo,
                      "d-flex",
                      "align-items-center",
                      "justify-content-center"
                    )}
                    offset={200}
                  >
                    <ReactPlayer
                      url={dkVideo}
                      playing={true}
                      loop={true}
                      controls={false}
                      muted={true}
                      // className={styles.innerContainerMobileVideo}
                      width="calc(100vw - 40px)"
                      // style={{ width: "calc(100vw - 40px)" }}
                    />
                  </LazyLoad> */}
          <p className={cx(styles.videoPara)}>
            Up Until Today, More Than 5000 People Have Visited Digikala
          </p>
          <Link
            aria-label='read more'
            href={`https://explore.digikala.com/${sharedData.utmParamsEn}`}
            target='_blank'
            className={cx(
              styles.readmoreBtnStylesReverce,
              'd-flex',
              'align-items-center',
              'justify-content-center'
            )}
          >
            Explore the Digikala Universe
          </Link>
        </div>
      </div>
    </>
  )
}

export default DKExploreHomeVideoEn
